import { useEnvironment } from '@publicisgroupe/p-os-components';
import { t } from 'utils/resources';
import { LoginPageImages } from 'types/types';
import { DEFAULT_LOGO } from 'utils/constants';
import { ClientLoginScreenEnum } from 'utils/enums';
import { isString } from 'lodash';

export const useLoginPageImages = () => {
  const { settings } = useEnvironment();
  const loginScreens = (settings as any).clientLoginScreen;
  const currentHost = window.location.host;
  const loginConfig = loginScreens?.[currentHost];
  const loginPageImagesData: LoginPageImages = {
    splashScreenBackgroundImage: `url(${settings.cdnBaseUrl}/webframe/header-bg.jpg)`,
    splashScreenLogo: DEFAULT_LOGO,
    desktopViewBackgroundImage: `${settings.cdnBaseUrl}/webframe/login_hero_sunset.jpg`,
    desktopViewLogo: DEFAULT_LOGO,
    mobileViewBackgroundImage: `${settings.cdnBaseUrl}/webframe/mobile-login-bg.png`,
    isClientLogin: false,
  };

  const getPageImages = (): LoginPageImages => {
    const clientLoginkeys = Object.keys(ClientLoginScreenEnum).filter((client) => isString(client));

    if (!clientLoginkeys.includes(loginConfig)) return loginPageImagesData;

    loginPageImagesData.desktopViewBackgroundImage = loginPageImagesData.mobileViewBackgroundImage =
      t(`${loginConfig}.BackgroundImage`);
    loginPageImagesData.desktopViewLogo = t(`${loginConfig}.Logo`);
    loginPageImagesData.isClientLogin = true;

    return loginPageImagesData;
  };

  return getPageImages();
};
